import { render } from "./Opening.vue?vue&type=template&id=d9fb7fe4&scoped=true"
const script = {}

import "./Opening.vue?vue&type=style&index=0&id=d9fb7fe4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9fb7fe4"],['__file',"src/views/Opening.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d9fb7fe4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d9fb7fe4', __exports__)) {
    api.reload('d9fb7fe4', __exports__)
  }
  
  module.hot.accept("./Opening.vue?vue&type=template&id=d9fb7fe4&scoped=true", () => {
    api.rerender('d9fb7fe4', render)
  })

}


export default __exports__